import { useContext } from "react";
import { TourContext, TourContextValue } from "@/providers/TourProvider";

export const useTour = (): TourContextValue => {
	const ctx = useContext(TourContext);
	if (!ctx)
		throw new Error("useTour must be used within a TourProvider");
	return ctx;
};
